module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.showData.title,
      "visible": _vm.AddDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.AddDialogVisible = $event
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showData.title == '新增会销订单'),
      expression: "showData.title=='新增会销订单'"
    }],
    staticStyle: {
      "color": "red",
      "font-size": "16px"
    }
  }, [_vm._v("(友情提示：部分浏览器存在兼容问题，请使用谷歌浏览器)")]), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "margin": "20px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "150px"
    }
  }, [_c('div', {
    staticClass: "v-com-form"
  }, [(_vm.showData.isReadOnly) ? _c('div', {
    staticClass: "v-com-matter"
  }) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代理商:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agent))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showData.isReadOnly),
      expression: "!showData.isReadOnly"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.chooseAgent
    }
  }, [_vm._v("选择代理商")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "园所:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.school))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showData.isReadOnly),
      expression: "!showData.isReadOnly"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.chooseSchool
    }
  }, [_vm._v("选择幼儿园")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showData.isReadOnly),
      expression: "!showData.isReadOnly"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.addSchool
    }
  }, [_vm._v("添加幼儿园")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "套餐:"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeValue
    },
    model: {
      value: (_vm.form.PackageId),
      callback: function($$v) {
        _vm.$set(_vm.form, "PackageId", $$v)
      },
      expression: "form.PackageId"
    }
  }, _vm._l((this.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.label,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "开通班级数:"
    }
  }, [_c('el-input-number', {
    attrs: {
      "step": _vm.step,
      "min": _vm.minNum
    },
    model: {
      value: (_vm.form.ClassNum),
      callback: function($$v) {
        _vm.$set(_vm.form, "ClassNum", $$v)
      },
      expression: "form.ClassNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单价格:"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.price) + "元")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配套实物商品:"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "proName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "proNum",
      "label": "商品数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "proNum2",
      "label": "本学期应发数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "proNum1",
      "label": "本次发货数量"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配套虚拟商品:"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "data": _vm.tableData2,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "proName",
      "label": "课程类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "proNum",
      "label": "课时数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "proNum2",
      "label": "本学期应发数"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择收货地址:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ConsigneeList))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showData.isReadOnly),
      expression: "!showData.isReadOnly"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.changeAddress
    }
  }, [_vm._v("选择地址")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收货人及联系方式:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ConsigneeListName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "寄送方式:",
      "label-width": "150px"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.SendMode),
      callback: function($$v) {
        _vm.$set(_vm.form, "SendMode", $$v)
      },
      expression: "form.SendMode"
    }
  }, _vm._l((_vm.transportList), function(item) {
    return _c('el-radio', {
      attrs: {
        "label": item.Id
      }
    }, [_vm._v(_vm._s(item.ParmName))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "寄送支付方式:",
      "label-width": "150px"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.PayMode),
      callback: function($$v) {
        _vm.$set(_vm.form, "PayMode", $$v)
      },
      expression: "form.PayMode"
    }
  }, _vm._l((_vm.PayList), function(item) {
    return _c('el-radio', {
      attrs: {
        "label": item.Id
      }
    }, [_vm._v(_vm._s(item.ParmName))])
  }))], 1)], 1), _vm._v(" "), _vm._l((_vm.payList), function(item, index) {
    return _c('payTypeInfo', {
      ref: 'payInfo' + (index + 1),
      refInFor: true,
      attrs: {
        "myIndex": (index + 1),
        "value": item,
        "isReadOnly": _vm.showData.isReadOnly,
        "hasDelFn": _vm.isDelShow[index]
      },
      on: {
        "delPayfn": _vm.delPayFn
      }
    })
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showData.isReadOnly),
      expression: "!showData.isReadOnly"
    }],
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.addFn
    }
  }, [_vm._v("新增支付方式")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showData.isReadOnly),
      expression: "!showData.isReadOnly"
    }],
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 1)], 2)], 1), _vm._v(" "), _c('chooseDialog', {
    ref: "chooseDialog",
    on: {
      "dialogList": _vm.getDialogList
    }
  }), _vm._v(" "), _c('AddressDialog', {
    ref: "AddressDialog",
    on: {
      "address": _vm.getAddress,
      "getSchoolConsigneeList": _vm.getSchoolConsigneeList
    }
  }), _vm._v(" "), _c('optOpenClassDialog', {
    ref: "refoptOpenClassDialog",
    on: {
      "shcoolList": _vm.getSchoolName
    }
  }), _vm._v(" "), _c('addAgent', {
    ref: "applyZzDialog",
    on: {
      "agentList": _vm.getAgent
    },
    model: {
      value: (_vm.addDialogVisiable),
      callback: function($$v) {
        _vm.addDialogVisiable = $$v
      },
      expression: "addDialogVisiable"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56464bf9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Order/MeetOrder/addSellingOrder/index.vue
// module id = 1486
// module chunks = 1